import React, { Component } from 'react';
import { Card, Image } from 'semantic-ui-react';

export default class ClubHistoryBasic extends Component {
  componentDidMount() {
    this.ClubHistoryCard = this.ClubHistoryCard.bind(this);
  }

  ClubHistoryCard(details, key) {
    return (
      <Card
        key={key}
        onClick={() => this.props.history.push(details.club.link)}
      >
        <Card.Content>
          <Card.Header textAlign="center">{details.club.title}</Card.Header>
          <Card.Meta textAlign="center">
            <span className="date">
              {details.startYear}{' '}
              {details.endYear ? ` - ${details.endYear}` : ' '}
            </span>
          </Card.Meta>
          <Card.Description>
            <Image src={details.club.image} />
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }

  render() {
    return (
      <Card.Group doubling={true} itemsPerRow="3" textAlign="center">
        {this.props.clubs.map((details, key) =>
          this.ClubHistoryCard(details, key)
        )}
      </Card.Group>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ClubHistory/ClubHistoryBasic.js